import React from 'react'

const Setting = () => {
  return (
    <div>
      
    </div>
  )
}

export default Setting
